/**
* 左边菜单
*/ 
<template>
   <!-- <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b"> -->
   <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img v-if="collapsed" class="logoimg" src="../assets/img/logo3.png" alt="">
      <img v-else class="logoimg" src="../assets/img/logo2.png" alt="">
    </div>
      <template v-for="(items, index) in allmenu">
        <el-submenu v-if="items.menus && items.menus.length > 0" :key="index" :index="items.url">
          <template slot="title">
            <!-- <i class="iconfont" :class="items.icon"></i> -->
            <i :class="items.icon"></i>
            <span style="margin-left: 20px;">{{items.menuName}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-for="chmenu in items.menus" :index="chmenu.url" :key="chmenu.menuid">
              <!-- <i class="iconfont" :class="chmenu.icon"></i> -->
              <i :class="chmenu.icon"></i>
              <span style="margin-left: 20px;">{{chmenu.menuName}}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-else :key="items.menuId" :index="items.url">
          <!-- <i class="iconfont" :class="items.icon"></i> -->
          <i :class="items.icon"></i>
          <span style="margin-left: 20px;">{{items.menuName}}</span>
        </el-menu-item>
      </template>
      <div class="motto" v-if="!collapsed">其生有涯 · 其知无涯</div>
    </el-menu>
    
</template>
<script>
import { getMenu, getBtn } from '../api/crmMG'
import { checkLogin } from '../utils/util'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getMenuList()
    this.getBtnList()
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })

  },
  methods: {
    // 获取权限菜单
    getMenuList() {
      getMenu()
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
            this.allmenu = res.data
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
        .catch(err => {
          this.$message.error('系统错误，请重新登录!')
        })
    },
    // 获取按钮权限
    getBtnList() {
      getBtn()
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
            // 按钮权限查询成功,存入缓存
            localStorage.setItem('btnAuth', JSON.stringify(res.data.btn_auth))
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
        .catch(err => {
          this.$message.error('系统错误，请重新登录!')
        })
    }
  }

}
</script>
<style lang="sss" scoped>
/* .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
} */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  /* height: 40px; */
  height: 20%;
  /* line-height: 40px; */
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px auto;
}
.logoimg {
  height: 48px;
  /* margin-top: 35%; */
  margin-top: 85px;
}
.logohiddenimg {
  height: 48px;
  margin-top: 75%;
}
ul {
  height: 100vh;
  background-image: url('../assets/img/leftnav-b.png');
  background-size: cover;
  width: 100% !important;
}
ul.el-menu-vertical-demo.el-menu {
  background-color: #004C55 !important;
}
li.el-menu-item {
  background-color: #004C55 !important;
  text-align: center !important;
  font-weight: 700;
  font-size: 16px;
}
li.el-submenu {
  background-color: #004C55 !important;
}
.el-submenu__title {
  background-color: #004C55 !important;
  text-align: center !important;
}
li.el-menu-item.is-active {
  background-color: transparent;
}
.asideshow {
  background-color: #004C55 !important;
}
.aside .is-active {
  width: 100% !important;
  border-radius: none !important;
}
.el-menu-item {
  border-radius: 10px !important;
  background-color: #00C8DF !important;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.el-menu-item i {
  color: #FFFFFF !important;
}
.el-menu-item.is-active i {
  color: #004C55 !important;
}
.el-menu-item.is-active {
  color: #004C55 !important;
  border-radius: 10px !important;
  background-color: #00C8DF !important;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.motto {
  color: #FFFFFF;
  text-align: center;
  position: absolute;
  left: 50px;
  font-size: 14px;
  bottom: 20px;
}
.aside .el-menu--collapse>.el-menu-item.is-active i {
  margin-left: 30px
}
.aside .el-menu--collapse>.el-menu-item i {
  margin-left: 20px
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue